import React, { Component } from 'react';
import { Spring, config } from 'react-spring';
import { css } from 'emotion';
import Link from 'gatsby-link';
import styles from './project-button.module.css';

const ProjectButton = ({
  currentPage,
  linkPath,
  buttonColor,
  buttonColorHover,
  isHome,
  returnSection,
}) => {
  const renderButton = animation => {
    return (
      <div
        style={animation}
        className={css`
          background-color: ${buttonColor};
          position: absolute;
          margin-top: 1em;
          font-size: 1em;
          display: flex;
          transition: background-color 0.25s ease;
          &:hover {
            background-color: ${buttonColorHover};
          }
        `}
      >
        <Link className={styles.link} to={`/our-work/${linkPath}`}>
          View case study
        </Link>
      </div>
    );
  };

  const renderHomeButton = () => {
    return (
      <Spring
        from={{ opacity: 0, transform: 'translateY(20px)' }}
        to={{
          opacity: returnSection === 'active' ? 1 : 0,
          transform:
            returnSection === 'active' ? 'translateY(0)' : 'translateY(20px)',
        }}
        delay={800}
        config={{ tension: 180, friction: 60 }}
      >
        {animation => renderButton(animation)}
      </Spring>
    );
  };

  const renderProjectButton = () => {
    if (isHome) {
      return renderHomeButton();
    } else if (currentPage !== 'ProjectTemplate') {
      return renderButton();
    }
  };

  return <React.Fragment>{renderProjectButton()}</React.Fragment>;
};

export default ProjectButton;



// WEBPACK FOOTER //
// ./src/components/project/project-button/index.js